import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_IconSwitcher = _resolveComponent("IconSwitcher");
    const _component_FormSelect = _resolveComponent("FormSelect");
    const _component_ColorSelect = _resolveComponent("ColorSelect");
    const _component_Section = _resolveComponent("Section");
    return (_openBlock(), _createBlock(_component_Section, {
        key: _ctx.molType,
        level: 2,
        title: _ctx.capitalize(_ctx.molType)
    }, {
        afterTitle: _withCtx(() => [
            _createVNode(_component_IconSwitcher, {
                useFirst: _ctx.isVisible,
                iconID1: ['far', 'eye'],
                iconID2: ['far', 'eye-slash'],
                icon2Style: { color: 'lightgray' },
                width: 24,
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.toggleVisible(_ctx.molType))),
                clickable: true,
                title: "Visible",
                tipPlacement: "left"
            }, null, 8, ["useFirst"])
        ]),
        default: _withCtx(() => [
            _createVNode(_component_FormSelect, {
                id: 'atoms-' + _ctx.molType,
                modelValue: _ctx.atomsOption,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.atomsOption) = $event)),
                options: _ctx.atomsStyleOptions,
                onOnChange: _cache[2] || (_cache[2] = ($event) => (_ctx.updateMolecules(_ctx.atomsOption)))
            }, null, 8, ["id", "modelValue", "options"]),
            (_ctx.atomsOption !== 'atoms-hidden')
                ? (_openBlock(), _createBlock(_component_ColorSelect, {
                    key: 0,
                    modelValue: _ctx.styleToUse,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.styleToUse) = $event)),
                    repName: _ctx.atomsOption,
                    onOnChange: _cache[4] || (_cache[4] = ($event) => (_ctx.updateMolecules(_ctx.atomsOption))),
                    allowColorCarbons: _ctx.molType !== 'metal',
                    allowSpectrum: false,
                    allowSecondaryStructure: _ctx.molType === 'protein'
                }, null, 8, ["modelValue", "repName", "allowColorCarbons", "allowSecondaryStructure"]))
                : _createCommentVNode("", true),
            (_ctx.molType === 'protein')
                ? (_openBlock(), _createBlock(_component_FormSelect, {
                    key: 1,
                    id: 'protein-' + _ctx.molType,
                    modelValue: _ctx.backboneOption,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.backboneOption) = $event)),
                    options: _ctx.proteinStyleOptions,
                    onOnChange: _cache[6] || (_cache[6] = ($event) => (_ctx.updateMolecules(_ctx.backboneOption)))
                }, null, 8, ["id", "modelValue", "options"]))
                : _createCommentVNode("", true),
            (_ctx.backboneOption !== 'backbone-hidden')
                ? (_openBlock(), _createBlock(_component_ColorSelect, {
                    key: 2,
                    modelValue: _ctx.styleToUse,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.styleToUse) = $event)),
                    repName: _ctx.backboneOption,
                    onOnChange: _cache[8] || (_cache[8] = ($event) => (_ctx.updateMolecules(_ctx.backboneOption))),
                    allowColorByElement: false,
                    allowColorCarbons: false
                }, null, 8, ["modelValue", "repName"]))
                : _createCommentVNode("", true),
            (_ctx.molType !== 'metal')
                ? (_openBlock(), _createBlock(_component_FormSelect, {
                    key: 3,
                    id: 'surface-' + _ctx.molType,
                    modelValue: _ctx.surfaceOption,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.surfaceOption) = $event)),
                    options: _ctx.metalStyleOptions,
                    onOnChange: _cache[10] || (_cache[10] = ($event) => (_ctx.updateMolecules(_ctx.surfaceOption)))
                }, null, 8, ["id", "modelValue", "options"]))
                : _createCommentVNode("", true),
            (_ctx.surfaceOption !== 'surface-hidden')
                ? (_openBlock(), _createBlock(_component_ColorSelect, {
                    key: 4,
                    modelValue: _ctx.styleToUse,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.styleToUse) = $event)),
                    repName: _ctx.surfaceOption,
                    onOnChange: _cache[12] || (_cache[12] = ($event) => (_ctx.updateMolecules(_ctx.surfaceOption))),
                    allowSpectrum: false,
                    allowSecondaryStructure: _ctx.molType === 'protein'
                }, null, 8, ["modelValue", "repName", "allowSecondaryStructure"]))
                : _createCommentVNode("", true)
        ]),
        _: 1
    }, 8, ["title"]));
}
